import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-bg-primary border-t border-border-color" data-id="element-237">
      <div className="container max-w-4xl mx-auto" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-6" data-id="element-240">
            No estás "mal".{' '}
            <span className="text-accent" data-id="element-241">Estás sin estructura.</span>
          </h2>
          <p className="text-lg text-text-secondary leading-relaxed max-w-2xl mx-auto" data-id="element-242">
            Muchos hombres intentan "ser interesantes" con fuerza… y eso se
            nota. El problema casi siempre es el mismo: energía de necesidad,
            comunicación confusa y presencia débil. Eso no se arregla con frases
            sueltas.{' '}
            <strong className="text-text-primary" data-id="element-243">
              Se arregla con un sistema.
            </strong>
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-244">
          {['Te esforzás y aun así sentís que te ignoran.', "Sos buen tipo, pero no proyectás ese 'algo'.", 'Te da nervio, hablás de más o te quedás corto.', 'Te comparás, te frustrás y terminás bajando tu estándar.'].map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start space-x-4 bg-bg-card p-6 rounded-xl border border-border-color/50 hover:border-border-color transition-colors" data-id="element-245">
              <XCircle className="w-6 h-6 text-red-500/80 flex-shrink-0 mt-1" data-id="element-246" />
              <p className="text-text-normal font-medium" data-id="element-247">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-248">
          <p className="text-xl font-heading font-semibold text-text-primary border-l-4 border-cta-primary pl-6 inline-block text-left max-w-2xl" data-id="element-249">
            El Método Magnético te da un marco claro para que tu confianza sea
            consistente, no suerte.
          </p>
        </motion.div>
      </div>
    </section>;
}